import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c5-five-two-one-one',
  templateUrl: './c5-five-two-one-one.component.html',
  styleUrls: ['./c5-five-two-one-one.component.scss']
})
export class C5FiveTwoOneOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
